/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .controller('ViewEditLinkModalController', [
        '$modalInstance',
        '$scope',
        'DateTools',
        'EsignatureDocumentInterceptor',
        'NodeShareLink',
        function ($modalInstance, $scope, DateTools, EsignatureDocumentInterceptor, NodeShareLink) {
            $scope.modal = $modalInstance.options;
            $scope.invitation = $scope.link;

            if ($scope.link.esignature) {
                $scope.esignature = EsignatureDocumentInterceptor.response({ resource: { ...$scope.link.esignature } });
            }

            let originalLink = angular.copy($scope.link);

            $scope.onTextClick = ($event) => $event.target.select();

            $scope.allowOnlyNumbers = () => {
                $scope.link.days_until_expiration = !isNaN($scope.link.days_until_expiration) ?
                    parseInt($scope.link.days_until_expiration, 10) : '';
            };

            $scope.linkChanged = () => {
                // Making sure that the language is always the same because we only want to compare the link's properties
                originalLink.language = $scope.link.language;
                originalLink.locale = $scope.link.locale;
                return !(angular.equals($scope.link, originalLink));
            };

            $scope.removeRecipient = (recipientIndex) => $scope.link.recipients.splice(recipientIndex, 1);

            $scope.save = () => {
                $scope.modal.loading = true;

                NodeShareLink.update({
                    node_uuid: $scope.link.node_uuid,
                    id: $scope.link.id,
                    ttl: _ttlToSend(),
                    single_use: $scope.link.single_use,
                    access_restriction: $scope.link.access_restriction,
                    password: $scope.link.password,
                    allow_guest_downloads: $scope.link.allow_guest_downloads,
                    recipients: $scope.link.recipients.map(({ type, email, recipient_entity_uuid }) => ({
                        type,
                        ...(email ? { email } : {}),
                        ...(recipient_entity_uuid ? { recipient_entity_uuid } : {})
                    }))
                }).$promise
                    .then(() => $modalInstance.close())
                    .finally(() => $scope.modal.loading = false);
            };

            $scope.cancel = $scope.close = () => {
                angular.copy(originalLink, $scope.link);
                $modalInstance.dismiss();
            };

            $scope.isSaveDisabled = () => {
                // Here too: link.never_expire != true. JS reasons. Batman NaNNaNNaN!
                return $scope.modal.loading ||
                    ($scope.link.never_expire != true && !$scope.link.days_until_expiration) ||
                    ($scope.link.isPublicWithPassword() && !$scope.link.password);
            };

            function _ttlToSend() {
                // Yes, link.never_expire == true because JavaScript, that's why...
                if ($scope.link.never_expire == true && !$scope.link.permissions.isTtlRequired()) {
                    return '';
                } else {
                    return parseInt($scope.link.days_until_expiration, 10) + DateTools.daysSince($scope.link.created_at);
                }
            };
        }
    ]);
